module.exports = __webpack_public_path__ + "img/deb16c6.png";